import {Component, Inject, OnInit, Optional} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {UntilDestroy} from '@ngneat/until-destroy';
import {DIALOG_DATA} from 'src/app/services/dialog.service';
import {DialogRef} from 'src/app/shared/ui-kits/dialog/dialog-ref';

@UntilDestroy()
@Component({
  selector: 'app-vacation-popup',
  templateUrl: './vacation-popup.component.html',
  styleUrls: ['./vacation-popup.component.scss'],
})
export class VacationPopupComponent implements OnInit {
  public annulment: UntypedFormControl = new UntypedFormControl(null);
  constructor(
    private dialogRef: DialogRef,
    @Optional() @Inject(DIALOG_DATA) public data: string
  ) {}
  ngOnInit(): void {
    this.annulment.setValue(this.data);
  }

  save() {
    this.dialogRef.close(this.annulment.value);
  }

  close() {
    this.dialogRef.close();
  }
}
